import React from 'react';
import { FormattedMessage } from 'react-intl';

function NoData(props) {
  return (
    <div className="nodata container d-flex justify-content-center align-items-center">
      <div className="d-flex justify-content-center align-items-center flex-column">
        <i className="record"></i>
        <span><FormattedMessage id='info.no_reserve_data' /></span>
      </div>
    </div>
    // <div className="nodata">
    //   <i className="record"></i>
    //   <span>查無資料</span>
    // </div>
  )
}

export default NoData;